import { createGlobalState } from 'react-hooks-global-state';

const initialState = {
  profileData: null,
  wandData: null,
  userInterestsData: null,
  userWandImage: null,
  userPatronusImage: null,
  userAvatarImage: null,
  selectedUserInterests: [],
};

const { setGlobalState, useGlobalState, getGlobalState } = createGlobalState(initialState);

export const setProfileData = (profileData) => {
  setGlobalState('profileData', profileData);
};

export const setDefaultWandData = (wandData) => {
  setGlobalState('wandData', wandData);
};

export const setUserWandImage = (wandImage) => {
  setGlobalState('userWandImage', wandImage);
};

export const setUserPatronusImage = (patronusImage) => {
  setGlobalState('userPatronusImage', patronusImage);
};

export const setUserAvatarImage = (avatarImage) => {
  setGlobalState('userAvatarImage', avatarImage);
};

export const setUserInterestsData = (userInterestsData) => {
  setGlobalState('userInterestsData', userInterestsData);
};

export const setSelectedUserInterests = (selectedUserInterests) => {
  setGlobalState('selectedUserInterests', selectedUserInterests);
};

export { useGlobalState, getGlobalState };
